import BuySellTable from "./buySellTable";

export default BuySellTable;



// WEBPACK FOOTER //
// ./src/components/common/buySellTable/index.js